module.exports = __webpack_public_path__ + "static/img/rank-icon.8bf5dcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/rank-icon.png
// module id = zwa4
// module chunks = 215